import { LightDomStyles, OutlineElement } from '@phase2/outline-core';
import { html, TemplateResult } from 'lit';
import { customElement } from 'lit/decorators.js';

import componentStyles from './outline-styled-text-baseline.css.lit';
import { OutlineHeadingBaseline } from '../outline-heading-baseline/outline-heading-baseline';
import { OutlineQuote } from '../outline-quote/outline-quote';
import { OutlineButtonBaseline } from '../outline-button-baseline/outline-button-baseline';
import { OutlineInlineLink } from '../outline-inline-link/outline-inline-link';
import { OutlineStyledTable } from '../outline-styled-table/outline-styled-table';
/**
 * The Baseline Styled Text component.
 * @element outline-styled-text-baseline
 * @slot defaultSlot
 */
@customElement('outline-styled-text-baseline')
export class OutlineStyledTextBaseline extends OutlineElement {
  static styles = [componentStyles];

  lightDomStyles = new LightDomStyles(
    this,
    [
      OutlineHeadingBaseline.styles,
      OutlineQuote.styles,
      OutlineButtonBaseline.styles,
      OutlineInlineLink.styles,
      OutlineStyledTable.styles,
      componentStyles,
    ],
    this.tagName.toLowerCase()
  );

  render(): TemplateResult {
    return html`<slot></slot> `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'outline-styled-text-baseline': OutlineStyledTextBaseline;
  }
}
